export const recommendationsFutureConfig = {
    "recommendations.**": {
        url: "/digitalsuite/recommendations",
        lazyLoad: () =>
            import(
                "single-spa/react-app/config/solutions25/genAIIntelligence/Recommendations/RecommendationsConfig"
            ),
    },
};
